import Vue from 'vue'
import VueResource from 'vue-resource'
import settings from '@/settings'

Vue.use(VueResource)

let apiUrl = settings.apiUrl
let version = settings.version

export default {
  GET_PACKAGES: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      Vue.http.get(`${apiUrl}${version}/payments/bigger-packages`).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  GET_HISTORY: ({ commit, dispatch }, params) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/payments/datatable`, params).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  SEND_PAYMENT: ({ commit, dispatch }, params) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/payments/invoices/create`, params).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  GET_PERMISSIONS: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      Vue.http.get(`${apiUrl}${version}/users/permissions`).then(res => {
        commit('SET_PERMISSIONS', res.body.permissions)
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  GET_USER_SUBSCRIPTION: ({ commit, dispatch }, userId) => {
    return new Promise((resolve, reject) => {
      Vue.http.get(`${apiUrl}${version}/users/${userId}/subscription`).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  /* params: {
        "package_id": 50,
        "keywords_extra": 20000,
        "projects_extra": 500,
        "links_extra": 6600,
        "reports_extra": 550,
        "history_extra": 220,
        "expiry_date": "2019-10-25"
  } */
  SET_USER_SUBSCRIPTION: ({ commit, dispatch }, {userId, params}) => {
    return new Promise((resolve, reject) => {
      Vue.http.put(`${apiUrl}${version}/users/${userId}/subscription`, params).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  SET_USER_SUBSCRIPTION_RENEW: ({ commit, dispatch }, renew) => {
    return new Promise((resolve, reject) => {
      Vue.http.put(`${apiUrl}${version}/users/subscription-renew`, { renew: renew }).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  GET_DISCOUNTS: ({ commit, dispatch }, params) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/discounts/datatable`, params).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  /*
    percentage: float
    from_date: datetime
    to_date: datetime
    user_id: Optional[int]
    product_id: Optional[int]
  */
  CREATE_DISCOUNT: ({ commit, dispatch }, discount) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/discounts`, discount).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  /*
    percentage: Optional[float]
    from_date: Optional[datetime]
    to_date: Optional[datetime]
    user_id: Optional[int]
    product_id: Optional[int]
  */
  EDIT_DISCOUNT: ({ commit, dispatch }, {discountId, discount}) => {
    return new Promise((resolve, reject) => {
      Vue.http.put(`${apiUrl}${version}/discounts/` + discountId, discount).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  // {'products': [{'id': int, 'quantity': int}], 'currency': int}
  CALCULATE_REFUND: ({ commit, dispatch }, params) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/payments/calculate-refund`, params).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  // {'currency_type': int, 'amount': float, 'user_id': int}, admin only
  CHANGE_USER_CREDITS: ({ commit, dispatch }, params) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/payments/transaction`, params).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  // params - typical datatable request
  GET_TRANSACTIONS: ({ commit, dispatch }, params) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/payments/transactions/datatable`, params).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  EXPORT_INVOICE: ({ commit, dispatch }, params) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/payments/receipt`, params, {
        responseType: 'arraybuffer',
        headers: {'Accept': 'application/octet-stream'}
      }).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/subscription/actions.js